import React from 'react';

const TrackingLine = () => {
  return (
    
    <div className="tracking-line-container">
      {/* */}
      <div className="tracking-glow" />
    </div>
  );
};

export default TrackingLine;